import Vue from 'vue';

export const state = () => ({
    data: {
        hits: 0,//点击量
    },
});

export const mutations = {
    updateData(state, n) {
        state.hits = n;
    },
};

export const getters = {

};

export const actions = {
    /**
     * 更新点击量
     * @param {Object} state state实例
     * @param {Object} obj 参数
     * @returns 
     */
    updateHits(state, data) {
        //source pc  电脑   applet  小程序
        Vue.prototype.$post(`${this.state.api.baseWebUrl}/sys/buried/point/add`, {...data,source:'pc'}, t => {
        }, true);
    },
};